
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Input, Select, Divider, Popover, Table, Image, Button, Modal, Form, Checkbox, Spin, notification, Progress } from 'antd';
import { useNavigate } from 'react-router-dom';
import { PlusOutlined, DeleteOutlined, FileImageOutlined, EditOutlined, SaveOutlined, FileAddOutlined, UploadOutlined, LoadingOutlined, SyncOutlined, } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { fetchData, sendData, sendDataPut } from '../../httpRequests';

import CreateNewProductsByFarmacy from '../Products/CreateNewProductByFarmacy';
import ExportJsonExcel from 'js-export-excel'

import * as XLSX from "xlsx"

const filterCategory = {
    filterCategory_id: 0,
}

const form = {

    product_id: null,
    stock: null,
    price: null,
    gift_price: null,
    gift_status: null,
    ivu_statal: null,
    ivu_municipal: null,
    status: null,
    product_category_id: null,
    upc: null,

    product_img: null,
    product_name: ""
}

const editAds = (
    <small>
        Edit
    </small>
);
const antIcon = <SyncOutlined style={{ fontSize: 50, color: '#128780' }} spin />;
export default function Products() {
    const navigate = useNavigate();

    const [formValuesCategories, setFormValuesCategories] = useState(filterCategory)
    const [categorys, setCategorys] = useState([]);
    const [categorys2, setCategorys2] = useState([]);

    const [products, setProducts] = useState([]);
    const [productQuantity, setProductQuantity] = useState(0)

    const { filterCategory_id } = formValuesCategories

    const { id } = useParams();
    const [pharmacy_id, setpharmacy_id] = useState((id) ? id : Number(localStorage.getItem('PHARMACY_LOGGED')))
    const [role_id, setRole_id] = useState(Number(localStorage.getItem('Role_id')))

    const [initial, seIinitial] = useState(0)
    const [limit, setLimit] = useState(10)
    const [selectCategorie, setSelectCategorie] = useState(0)
    const [active, setActive] = useState(2)
    const [selectCurrent, setSelectCurrent] = useState(1)

    const [tbLoading, setTbLoading] = useState(false)

    const [text, setText] = useState('')

    const [showModalEdit, setShowModalEdit] = useState(false)
    // const [closeProductModal, setCloseProductModal] = useState(true)
    const [formValues, setFormValues] = useState(form)

    const [seeImgInput, setSeeImgInput] = useState(null);

    const [isModalVisibleCreateProductList, setIsModalVisibleCreateProductList] = useState(false);
    const [fileSeleted, setFileSeleted] = useState('')
    const [nameFile, setNameFile] = useState('')
    const [isLoading, setIsLoading] = useState(false);
    const [initPorcent, setInitPorcent] = useState(0);

    const {

        product_id,

        gift_price,
        gift_status,

        ivu_municipal,
        status,

        product_category_id,
        upc,
        product_img,
        product_name,
        stock,
        price,
        ivu_statal
    } = formValues

    useEffect(() => {
        getProducts()
        getCategorys()
        getCategorys2()
    }, [])

    useEffect(() => {
        getProducts()
    }, [selectCategorie, active])

    const getCategorys = () => {
        const url = '/categories/getCategories';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const categories = response['category'];
                let allCategory = categories
                allCategory.unshift({ id: 0, name: 'All' })
                setCategorys(allCategory)

            }
        })
    }
    const getCategorys2 = () => {
        const url = '/categories/getCategories';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                // const categories2 = response['category'];
                setCategorys2(response.category)
                // console.log(categories2)
            }
        })
    }

    const getProducts = () => {
        setTbLoading(true)
        const url = `/products/getProductsByPharmacyNewPanel/${limit}/${initial}/${selectCategorie}/${active}/${pharmacy_id}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const products = response['pharmacyproduct'];
                const productQuantity = response['productQuantity'];
                setProducts(products)
                setProductQuantity(productQuantity)
            }
            setTbLoading(false)
        })
    }

    const reloaDataPhather = () => {
        getProducts()
    }

    const columns = [
        {
            title: '',
            render: ({ product_img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={product_img ? product_img : "http://openmart.online/frontend/imgs/no_image.png?v=1"} />
                </div>
            )
        },
        { title: 'Upc', dataIndex: 'upc', key: 'upc' },
        {
            title: 'Name',
            dataIndex: 'product_name',
            key: 'product_name',
            defaultSortOrder: 'ascend',
        },
        { title: 'Category', dataIndex: 'category_name', key: 'category_name' },
        {
            title: 'Price',
            render: ({ price }) => <span>${price}</span>,
            key: 'price'
        },
        { title: 'Quantity', dataIndex: 'stock', key: 'stock' },
        {
            title: 'Status',
            render: ({ status }) => {
                return <span>{(status == 1 && 'Active') || 'Inactive'}</span>;
            },
            key: 'status'
        },
        {
            title: 'ACTION',
            render: ({ ...data }) => (
                <div style={{ display: 'flex' }} onClick={() => editProduct(data)}>
                    <Popover content={editAds} trigger="hover">
                        <span style={{ margin: 10, cursor: 'pointer' }}>
                            <EditOutlined style={{ fontSize: '25px', color: '#128780' }} />
                        </span>
                    </Popover>
                </div>
            )
        }
    ];

    const handleFilter = async (e) => {
        setText('')
        seIinitial(0)
        setLimit(10)
        setSelectCurrent(1)

        setSelectCategorie(e)

        setFormValuesCategories({
            ...formValuesCategories,
            filterCategory_id: e

        })

    }

    const handleFilterModalCategory = async (e) => {
        setFormValues({
            ...formValues,
            product_category_id: e
        })
    }

    const handleFilterActiveProduct = (e) => {
        setText('')
        seIinitial(0)
        setLimit(10)
        setActive(e)
        setSelectCurrent(1)

    }

    const handlePa = async (value, value2) => {
        console.log(value.pageSize)
        setLimit(value.pageSize)
        setSelectCurrent(value.current)

        let takedValue;
        if (value.current == 1) {
            takedValue = 0
            seIinitial(0)
        } else {
            takedValue = 10 * value.current - 10
            console.log(takedValue)
            seIinitial(takedValue)
        }

        if (text == '') {
            const url = `/products/getProductsByPharmacyNewPanel/${value.pageSize}/${takedValue}/${selectCategorie}/${active}/${pharmacy_id}`;
            fetchData(url).then((response) => {
                if (Object.keys(response).length > 0) {
                    const products = response['pharmacyproduct'];
                    const productQuantity = response['productQuantity'];
                    setProducts(products)
                    setProductQuantity(productQuantity)
                }
                // setTbLoading(false)
            })
        } else {
            const url = `/products/getProductsByPharmacyNewPanelSearch/${value.pageSize}/${takedValue}/${selectCategorie}/${active}/${pharmacy_id}`;
            sendData(url, { text }).then((response) => {
                const products = response['pharmacyproduct'];
                setProducts(products)
                setProductQuantity(response.productQuantity)

            })
        }

    }

    // buscador
    const onSearch = (value) => {
        setProducts([])
        // setFilteredProducts([])

        seIinitial(0)
        setLimit(10)
        setSelectCurrent(1)



        // setFormValues({
        //     ...formValues,
        //     category_id: 0

        // })


        let texto = value.target.value
        setText(texto)




        if (texto != '') {
            const url = `/products/getProductsByPharmacyNewPanelSearch/${limit}/${0}/${selectCategorie}/${active}/${pharmacy_id}`;
            sendData(url, { text: texto.trim() }).then((response) => {
                const products = response['pharmacyproduct'];
                setProducts(products)
                setProductQuantity(response.productQuantity)
                console.log(response)
            })
        } else {
            getProducts()

        }
    }
    const editProduct = (data) => {
        if (data.price <= 0) {
            setFormValues({
                ...data, status: 0, ivu_municipal: 0,
                ivu_statal: 0,
                gift_status: 0,
            })
           
        }else{
            setFormValues({
                ...data,
            })
        }
        setShowModalEdit(true)
    }

    const closeModalEdit = () => {
        setShowModalEdit(false)
    }

    const handleInputChange = ({ target }) => {


        setFormValues({
            ...formValues,
            // status: 0,
            [target.name]: target.value
        })




    }
    const handleInputChangePrice = ({ target }) => {
        console.log(target.value)
        if (target.value <= 0) {
            setFormValues({
                ...formValues,
                status: 0,
                ivu_municipal: 0,
                ivu_statal: 0,
                gift_status: 0,
                [target.name]: target.value
            })
        }
        else {
            setFormValues({
                ...formValues,
                [target.name]: target.value
            });
        }


    }
    const handleInputChangeCheckbox = ({ target }) => {
        if (Number(price) > 0) {
            setFormValues({
                ...formValues,
                [target.name]: target.checked
            });
        } else {
            setFormValues({
                ...formValues,
                [target.name]: false
            });
        }
    }
    const handleSubmit = async (values) => {

        const url = '/products/updateProductByPharmacy';
        const data = {
            name: product_name,
            pharmacy_id,
            product_id,
            stock: Number(stock),
            price: Number(price),
            gift_price: Number(gift_price),
            gift_status: gift_status ? 1 : 0,
            ivu_statal: ivu_statal ? 1 : 0,
            ivu_municipal: ivu_municipal ? 1 : 0,
            active: status ? 1 : 0,
            category_id: product_category_id,
            upc: upc
        };

        if (seeImgInput != null && seeImgInput != undefined) {
            await handleFile(data.product_id)
        }
        sendData(url, data).then((response) => {
            if (Object.keys(response).length > 0) {
                setShowModalEdit(false)
                openNotificationWithIcon('success', 'product updated successfully')
                getProducts()
            }
        });

        console.log(data)
    }
    const openNotificationWithIcon = (type, mensaje) => {
        notification[type]({
            description: mensaje
        });
    };

    const handleFile = async (id) => {
        let cloudurl = (window.location.hostname.includes('localhost'))
            ? `http://localhost:3003/api/products/updateProductPhoto/${id}`
            : `https://coopharma-api-zd5is.ondigitalocean.app/api/products/updateProductPhoto/${id}`

        let file = seeImgInput.target.files[0]
        const formData = new FormData();
        formData.append('image', file);
        try {
            const resp = await fetch(cloudurl, {
                method: 'post',
                body: formData
            });

            if (resp.ok) {
                const cloudResp = await resp.json();
                setSeeImgInput(null)
            }
        } catch (error) {
            console.log(error, "error")
        }
    }

    const seeFileProduct = async () => {
        if (seeImgInput.target.files[0] != undefined) {
            const image = document.getElementById("image-selected");
            const reader = new FileReader();
            reader.readAsDataURL(seeImgInput.target.files[0]);
            reader.onload = (seeImgInput) => {
                seeImgInput.preventDefault();
                image.setAttribute('src', seeImgInput.target.result)
            }
        } else {
            setSeeImgInput(null)
        }
    }

    useEffect(() => {
        if (seeImgInput != null) {
            seeFileProduct()
        }
    }, [seeImgInput])


    const handleOkFile = () => {
        setIsModalVisibleCreateProductList(false);
    };

    const handleCancelFile = () => {
        setIsModalVisibleCreateProductList(false);
    };

    const showModalCreateProductList = () => {
        setIsModalVisibleCreateProductList(true);
    };

    const exportExcel = () => {
        let option = {};
        option.fileName = 'Copharma'; // nombre de archivo
        // name price quantity upc
        option.datas = [
            {
                sheetData: [
                    // { one: "name", two: "upc", three: "quantity", four:"price" },

                ],// datos
                sheetName: 'Copharma', // nombre de la hoja
                sheetFilter: ['two', 'one', 'three', 'four'], // filtrado de columna
                sheetHeader: ['name', 'upc', 'quantity', 'price'], // encabezado de la primera fila
                // columnWidths: [20, 20] // el ancho de la columna debe corresponder al orden de la columna
            },
            // varias tablas

        ];

        const toExcel = new ExportJsonExcel(option); //new
        toExcel.saveExcel(); // Guardar

    }

    const readExcel = (file) => {
        if (file == '' || file == null || file == undefined) {
            setNameFile('')
            setFileSeleted('')
        } else {
            // console.log(file)
            setNameFile(file.name)
            setFileSeleted(file)
        }
    }


    const saveProductFile = async () => {
        // inti file
        setIsLoading(true)
        const promise = new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.readAsArrayBuffer(fileSeleted);

            fileReader.onload = (e) => {
                const bufferArray = e.target.result;

                const wb = XLSX.read(bufferArray, { type: "buffer" });

                const wsname = wb.SheetNames[0];

                const ws = wb.Sheets[wsname];

                const data = XLSX.utils.sheet_to_json(ws);

                resolve(data)
            };

            fileReader.onerror = (error) => {
                reject(error)
                setIsLoading(false)
            };
        });

        promise.then(async (d) => {
            const id = pharmacy_id
            let init = 0
            let fin = 0
            let entrada = []
            let total = Math.floor(d.length / 5)

            for (let i = 0; i <= total; i++) {
                init = i * 5
                fin = fin + 5
                entrada.push(d.slice(init, fin))
            }

            for (let i in entrada) {
                let response = await sendData(`/pharmacies/cargaMasiva/${id}`, entrada[i])
                if (response.ok) {
                    setInitPorcent(Math.round((i / entrada.length) * 5))
                    if (i == entrada.length - 1) {
                        setIsLoading(false)
                        // loadCategories()
                        openNotificationWithIcon('success', 'product added successfully')
                    }
                } else {
                    openNotificationWithIcon('warning', 'This file does not meet the requirements.')
                    openNotificationWithIcon('warning', 'an error has occurred contact the administrator.')
                }
            }
            setInitPorcent(1)
        })
    }



    return (
        <div>
            <Row gutter={24}>
                <Col span={6}>
                    <Input
                        size='large'
                        type='text'
                        name="texto"
                        value={text}
                        onChange={onSearch}
                        placeholder='Search Product'
                    />
                </Col>
                <Col span={5}>
                    <Select style={{ width: '100%' }} defaultValue={filterCategory_id} size='large' onChange={handleFilter} name="category_id" value={filterCategory_id} >
                        {categorys.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>

                <Col span={4}>
                    <Select style={{ width: '100%' }} defaultValue={2} size='large' name="" onChange={handleFilterActiveProduct}>
                        <Select.Option value={2}>
                            All
                        </Select.Option>
                        <Select.Option value={1}>
                            Active
                        </Select.Option>
                        <Select.Option value={0}>
                            Inactive
                        </Select.Option>

                    </Select>
                </Col>
                {(role_id != 4) ? <Col span={3}>
                    <Button
                        onClick={() => navigate('/newProduct')}
                        type='primary'
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                    >

                        Add Product
                    </Button>
                </Col>
                    : <Col span={3}>
                        <Button
                            onClick={() => navigate(`/admin/pharmacyNewProduct/${pharmacy_id}`)}
                            type='primary'
                            size='large'
                            style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}
                        >

                            Add Product
                        </Button>
                    </Col>}
                <Col span={3}>
                    <Button type='primary'
                        onClick={showModalCreateProductList}
                        size='large' style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}>Add List</Button>

                </Col>
                <Col span={3}>
                    <CreateNewProductsByFarmacy reloaDataPhather={reloaDataPhather} />
                </Col>
            </Row>
            <Divider />

            <Row gutter={24}>
                <Col span={24}>
                    <Table columns={columns} dataSource={products} rowKey={(item) => item.id} onChange={handlePa} loading={tbLoading}
                        pagination={{ pageSize: limit, total: productQuantity, current: selectCurrent }}
                    />

                </Col>
            </Row>

            <Modal visible={showModalEdit} onCancel={closeModalEdit} width={700}
                footer={null}
                closable={true}
            >
                <Form>
                    <Row gutter={24}>
                        <Col span={8} style={{ justifyContent: 'center', display: 'flex', alignItems: 'center' }}>
                            <div
                                style={{
                                    width: 160
                                }}
                            >
                                <Image src={product_img ? product_img : "http://openmart.online/frontend/imgs/no_image.png?v=1"} />
                            </div>
                        </Col>

                        <Col span={16}>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <label htmlFor=""><b>Name</b></label>
                                    <Input
                                        type='text'
                                        size='large'
                                        name="product_name"
                                        value={product_name}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col span={12}>
                                    <label htmlFor=""><b>Upc</b></label>
                                    <Input
                                        type='text'
                                        size='large'
                                        name="upc"
                                        value={upc}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col span={24} className='formMarginInput'>
                                    <label htmlFor=""> <b>Category</b></label>
                                    <Select style={{ width: '100%' }} size='large' name="category_id" value={product_category_id} onChange={handleFilterModalCategory}>
                                        {categorys2.map((c) => (
                                            <Select.Option key={c.id} value={c.id}  >
                                                {c.name}
                                            </Select.Option>
                                        ))
                                        }
                                    </Select>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <label htmlFor=""><b>Quantity</b></label>
                                    <Input
                                        type='number'
                                        size='large'
                                        name="stock"
                                        value={stock}
                                        onChange={handleInputChange}
                                    />
                                </Col>
                                <Col span={12}>
                                    <label htmlFor=""><b>Price</b></label>
                                    <Input
                                        type='number'
                                        size='large'
                                        name="price"
                                        value={price}
                                        onChange={handleInputChangePrice}
                                    />
                                </Col>
                                <Col span={5} className='formMarginInput'>
                                    <Row gutter={24}>
                                        <Col span={24}>
                                            <label htmlFor=""> State TAX </label>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox
                                                name="ivu_statal"
                                                checked={ivu_statal}
                                                onChange={handleInputChangeCheckbox}
                                            />
                                        </Col>
                                    </Row>
                                </Col>

                                <Col span={7} className='formMarginInput'>
                                    <Row gutter={24}>
                                        <Col span={24}>
                                            <label htmlFor=""> Municipal TAX</label>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox
                                                size='large'
                                                name="ivu_municipal"
                                                checked={ivu_municipal}
                                                onChange={handleInputChangeCheckbox}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={3} className='formMarginInput'>
                                    <Row gutter={24}>
                                        <Col span={24}>
                                            <label htmlFor="">Gift</label>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox
                                                size='large'
                                                name="gift_status"
                                                checked={gift_status}
                                                onChange={handleInputChangeCheckbox}

                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col span={9} className='formMarginInput'>
                                    <label htmlFor="">Gift Price</label>
                                    <Input
                                        size='large'
                                        type='number'
                                        name="gift_price"
                                        value={gift_price}
                                        onChange={handleInputChange}
                                        disabled={gift_status == false}
                                    />

                                </Col>
                                <Col span={5} className='formMarginInput'>
                                    <Row gutter={24}>
                                        <Col span={24}>
                                            <label htmlFor="">Active</label>
                                        </Col>
                                        <Col span={24}>
                                            <Checkbox
                                                size='large'
                                                name="status"
                                                checked={status}
                                                onChange={handleInputChangeCheckbox}

                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <label htmlFor="" >Change Image</label>
                                    <div className='bordereFile' style={{ marginTop: "10px" }}>
                                        <div className='file-select'>
                                            <div className='drag'>
                                                <div>
                                                    <div style={{ textAlign: 'center' }}>

                                                        <FileImageOutlined style={{ fontSize: '32px', color: 'white' }} />
                                                    </div>
                                                    <div style={{ textAlign: 'center' }}>
                                                        <b style={{ fornSize: '17px', color: 'white' }}>Add Image</b>
                                                    </div>
                                                    <p style={{ color: 'white' }}>or drag and drop</p>
                                                </div>
                                            </div>
                                            <input type="file" onChange={(e) => setSeeImgInput(e)} accept="image/x-png,image/gif,image/jpeg" />
                                        </div>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    {(seeImgInput != null) ? <img src="" alt="" id="image-selected" height="150px" width="150px" style={{ marginTop: "30px" }} /> : <div><img style={{ marginTop: "30px" }} height="150px" width="150px" src="http://openmart.online/frontend/imgs/no_image.png?" alt="" /></div>}
                                </Col>
                                <Col span={24}>
                                    <Button
                                        onClick={handleSubmit}
                                        type='primary'
                                        size='large'
                                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5, marginTop: '15px' }}
                                    // disabled={name == '' || upc == null || upc == ''}
                                    >
                                        <SaveOutlined />
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </Col>

                    </Row>
                </Form>
            </Modal>

            <Modal title="Add File " visible={isModalVisibleCreateProductList} onOk={handleOkFile} onClick={saveProductFile}
                onCancel={handleCancelFile}
                footer={[
                    <Button key='back' type='primary' disabled={fileSeleted == ''} onClick={saveProductFile}
                        size='large'
                        style={{ backgroundColor: '#128780', width: '100%', borderRadius: 5 }}>
                        <SaveOutlined />
                        save File</Button>
                ]}
            >
                <div onClick={exportExcel} className="clickdowload">Click here to download excel</div>
                <hr />
                <ul>
                    <li><strong>Name: </strong> <small>Name of product.</small></li>
                    <li><strong>Upc: </strong><small>Universal product code.</small></li>
                    <li><strong>Price: </strong><small>Price of product.</small></li>
                    <li><strong>Quantity: </strong><small>Quantity of produc.</small></li>
                </ul>
                <hr />

                <div className='bordereFile'>
                    <div className='file-select'>

                        <div className='drag'>
                            <div>
                                <div style={{ textAlign: 'center' }}>
                                    <FileAddOutlined style={{ fontSize: '32px', color: 'white' }} />
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <b style={{ fornSize: '17px', color: 'white' }}>Add File</b>
                                </div>
                                <p style={{ color: 'white' }}>or drag and drop</p>
                            </div>
                        </div>
                        <input type="file" onChange={(e) => {
                            const file = e.target.files[0]
                            readExcel(file)
                        }} />
                    </div>
                </div>
                {
                    nameFile == '' ? (<small style={{ color: 'red' }}>No file selected</small>)
                        : (<small><span>{nameFile}</span></small>)
                }
                {
                    isLoading == true ? (<Col span={24} style={{ textAlign: 'center', padding: '10px' }} >
                        <Spin tip="Please Wait This may take a while...." indicator={antIcon}>
                        </Spin>

                        <Progress
                            strokeColor={{
                                '0%': '#108ee9',
                                '100%': '#87d068',
                            }}
                            percent={initPorcent}
                        />
                    </Col>)
                        : (<></>)
                }


            </Modal>

        </div>
    )
}